import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Typography, Button, Paper, Tooltip, TableContainer, Modal, Table, TableBody, Divider, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, alpha } from "@mui/material";

import dayjs from "dayjs";

import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { tokens } from "../../../theme/theme";
import GlobalConfig from "../../../config/date/GlobalConfig";


import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import Close from '@mui/icons-material/Close';
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
const ChildReelWiseReamProductionReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };

    const [loading, setLoading] = useState(false);
    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);
        callApi(API_ENDPOINTS.REPORT_GetreportChildReelWiseReamProductionDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setLoadingData(data);
                setLoading(false);

            })
            .catch(error => {
                alert(error);
                setLoading(false);
            });

    };

    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]);


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
        cutter_operator: '',
        fno: ''
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "REAM SHIFT DATE", key: "date" },
        { header: "SHIFT.", key: "shift_code" },
        { header: "PO NO.", key: "po_no" },
        { header: "ROLL NO", key: "pr_number" },
        { header: "REEL NO", key: "cr_number" },
        { header: "QUALITY", key: "item_code" },
        { header: "GRADE", key: "grade" },
        { header: "GSM", key: "gsm" },
        { header: "SIZE 1", key: "width" },
        { header: "SIZE 2", key: "length" },
        { header: "NO OF SHEET", key: "no_of_sheets" },
        { header: "REAM WT.", key: "ream_weight" },
        { header: "PKT REAM", key: "reams_in_bundle" },
        { header: "NO OF REAMS", key: "total_reams" },
        { header: "TOTAL WEIGHT", key: "bundle_weight" },
        { header: "ITEM", key: "size" },
        { header: "REMARKS", key: "remarks" },
        { header: "LOCATION", key: "b_location" },
        { header: "SUPERVISOR", key: "cutter_operator" },
        { header: "FNO", key: "fno" },
         { header: "REPULP QTY", key: "repulp_qty" },
          { header: "WINDER REMARKS", key: "winder_remarks" },
    ];

    const dateColumnIndexes = [0]; // "DATE"

    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData,
            fileName: 'Ream Production Detail Report.xlsx',
            sheetName: 'Ream Production Details',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,


        });

        // const formattedData = filteredData.map(row => ({

        //     "REAM SHIFT DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "SHIFT.": row.shift_code,
        //     "PO NO.": row.po_no,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.cr_number,
        //     "QUALITY": row.item_code,
        //     "GRADE": row.grade,
        //     "GSM": row.gsm,
        //     "SIZE 1": row.width,
        //     "SIZE 2": row.length,
        //     "NO OF SHEET": row.no_of_sheets,
        //     "REAM WT.": row.ream_weight,
        //     "PKT REAM": row.reams_in_bundle,
        //     "NO OF REAMS": row.total_reams,
        //     "TOTAL WEIGHT": row.bundle_weight,
        //     "ITEM": row.size,
        //     "REMARKS": row.remarks,
        //     "LOCATION": row.b_location,


        // }));     


    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);


    const uniqueValues = {
        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        po_no: [...new Set(loadingData.map(row => row.po_no))],
        pr_number: [...new Set(loadingData.map(row => row.pr_number))],
        cr_number: [...new Set(loadingData.map(row => row.cr_number))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        grade: [...new Set(loadingData.map(row => row.grade))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        b_location: [...new Set(loadingData.map(row => row.b_location))],
        cutter_operator: [...new Set(loadingData.map(row => row.cutter_operator))],
        fno: [...new Set(loadingData.map(row => row.fno))],
    };


    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const columns = ['date', 'shift_code', 'po_no', 'pr_number', 'cr_number', 'item_code', 'grade', 'gsm', 'width', 'length', 'no_of_sheets', 'ream_weight', 'reams_in_bundle', 'total_reams', 'bundle_weight', 'size', 'remarks', 'b_location','cutter_operator','fno','repulp_qty','winder_remarks'];

    const autoCompleteColumns = ['shift_code', 'po_no', 'pr_number', 'cr_number', 'item_code', 'grade', 'gsm', 'b_location','cutter_operator','fno','repulp_qty','winder_remarks'];

    const totals = {
        no_of_sheets: filteredData.reduce((sum, r) => sum + (parseFloat(r.no_of_sheets) || 0), 0),
        ream_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.ream_weight) || 0), 0),
        total_reams: filteredData.reduce((sum, r) => sum + (parseFloat(r.total_reams) || 0), 0),
        bundle_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.bundle_weight) || 0), 0),
    };

    return (
        <>

            <Grid container padding="5px 0px 5px 0px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >


                <Box ml={1}>
                    <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >Ream Production Detail Report</Typography>
                </Box>

                <Grid item mt="2px" ml="5px" marginRight="auto" justifyContent="center">
                    <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                </Grid>

            </Grid>


            <Divider />


            <Grid container padding="5px 0px 5px 0px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-start" }} >

                <Grid ml={1} item xs={2} sm={3} md={1.5} lg={1.5} xl={1.5} mt="5px">

                    <CustomDatePicker
                        value={FromDate}
                        onChange={(date) => handleDateChange2(date)}
                        autoFocus={true}
                    />
                </Grid>


                <Grid item mt="2px" ml="10px" mr="10px">
                    <Typography fontWeight="bold">-</Typography>
                </Grid>


                <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1.5} mt="5px" mr="10px">

                    <CustomDatePicker
                        value={ToDate}
                        onChange={(date) => handleDateChange1(date)}
                    />
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                <Grid item mt="2px" ml="0px" mr="auto">

                    <Tooltip title="Download Report" onClick={HandleClose}>
                        <IconButton >
                            <FileDownloadIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Divider />


            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                <CustomTableContainer colors={colors}>
                    <TableContainer stickyHeader>
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table size="small" stickyHeader>
                                <TableHead sx={{ height: 10, fontWeight: 'bold' }}>
                                    <TableRow>
                                        <TableCell >REAM SHIFT DATE</TableCell>
                                        <TableCell >SHIFT</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap" }}>PO NO.</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 110, whiteSpace: "nowrap" }}>JUMBO NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 110, whiteSpace: "nowrap" }}>REEL NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 110, whiteSpace: "nowrap" }}>QUALITY</TableCell>
                                        <TableCell >GRADE</TableCell>
                                        <TableCell >GSM</TableCell>
                                        <TableCell >SIZE1</TableCell>
                                        <TableCell >SIZE2</TableCell>
                                        <TableCell >NO OF SHEET</TableCell>
                                        <TableCell >REAM WT.</TableCell>
                                        <TableCell >PKT.REAM</TableCell>
                                        <TableCell >NO.OF.REAMS</TableCell>
                                        <TableCell >TOTAL WEIGHT</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 110, whiteSpace: "nowrap" }}>ITEM</TableCell>
                                        <TableCell >REMARKS</TableCell>
                                        <TableCell >LOCATION</TableCell>
                                        <TableCell >SUPERVISOR</TableCell>
                                        <TableCell >F.NO</TableCell>
                                         <TableCell >REPULP QTY</TableCell>
                                          <TableCell >WINDER REMARKS</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />
                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>
                                            <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>{row.date}</TableCell>
                                            <TableCell >{row.shift_code}</TableCell>
                                            <TableCell>{row.po_no}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.cr_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.gsm}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.width}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.length}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.no_of_sheets}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.ream_weight}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.reams_in_bundle}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.total_reams}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.bundle_weight}</TableCell>
                                            <TableCell>{row.size}</TableCell>
                                            <TableCell>{row.remarks}</TableCell>
                                            <TableCell>{row.b_location}</TableCell>
                                             <TableCell>{row.cutter_operator}</TableCell>
                                              <TableCell>{row.fno}</TableCell>
                                               <TableCell sx={{ textAlign: 'right' }}>{row.repulp_qty}</TableCell>
                                                <TableCell sx={{ textAlign: 'right' }}>{row.winder_remarks}</TableCell>
                                        </TableRow>
                                    ))}

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={10} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.no_of_sheets.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.ream_weight.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE2 */}
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.total_reams.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.bundle_weight.toFixed(2)}</TableCell>
                                        <TableCell /> {/* REEL REF.NO */}
                                        <TableCell /> {/* REEL/SHEET */}
                                        <TableCell /> {/* REEL/SHEET */}
                                         <TableCell /> 
                                                                                 
                                          <TableCell /> 
                                    </TableRow>
                                </TableBody>
                            </Table>
                        )}
                    </TableContainer>


                </CustomTableContainer>
                <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />

            </ResponsiveBox>




        </>
    )
};
export default ChildReelWiseReamProductionReport;